import React from "react"
import { Grid, Typography } from "@material-ui/core"

import { SvgIcon } from "@/components"
import { AIIcon } from "@/assets/icons"

import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockAIFooter/styles"

type BlockAIFooterProps = {
	isAIActive: boolean
}

const BlockAIFooter: React.FC<BlockAIFooterProps> = (props) => {
	const { isAIActive } = props

	const classes = useStyles({ isAIActive })

	const footerLabel = isAIActive ? "Este bloco está utilizando IA" : "Este bloco não está utilizando IA"

	return (
		<Grid
			container
			alignItems="center"
			className={classes.footerContainer}
		>
			<Grid item className={classes.iconWrapper}>
				<SvgIcon
					icon={AIIcon}
					fontSize="small"
					autoSize
					className={classes.icon}
				/>
			</Grid>

			<Grid item>
				<Typography
					variant="caption"
					className={classes.label}
				>
					{footerLabel}
				</Typography>
			</Grid>
		</Grid>
	)
}

export default BlockAIFooter
